import {
  DatePickerInput as MantineDatePickerInput,
  DatePickerInputProps as MantineDatePickerInputProps,
} from "@mantine/dates"
import { forwardRef } from "react"

export const DatePickerInput = forwardRef<
  HTMLButtonElement,
  MantineDatePickerInputProps<"range" | "multiple" | "default">
>((props, ref) => {
  return (
    <MantineDatePickerInput
      ref={ref}
      {...props}
      size="xs"
      placeholder="Pick a date"
      styles={{
        input: {
          border: " 1px solid var(--mantine-color-gray-2)",
          backgroundColor: "var(--mantine-color-white)",
          minWidth: "150px",
        },
      }}
    />
  )
})
